document.addEventListener('click', (ev) => {
  if (!ev.target.closest('#staff-only-copy-logrocket-session')) return
  if (!window.LogRocket) return

  window.LogRocket.getSessionURL((sessionURL) => {
    navigator.clipboard.writeText(sessionURL).catch((err) => {
      console.error('Failed to copy LogRocket session URL', err)
    })
  })
})

export default {}
